import {FlexCol, FlexRow} from "src/utils/flexLayouts";
import {Modal} from "src/components/DialogComponent";
import TGButton from "src/components/ui/TGButton";
import {FC, useContext, useState} from "react";
import {useFormContext} from "react-hook-form";
import {IAnswer, IQuestion, QUESTION_TYPES, TEST_STATUSES} from "../Tests/types";
import {PassingTestContext} from "./passingTestContext";

interface IProps {
  countRightAnswers: number;
}

const ModalResultPassingTest: FC<IProps> = ({countRightAnswers}) => {
  const {setValue} = useFormContext();
  const [openDialog, setOpenDialog] = useState(false);
  const {questions, minCorrectAnswerCount, answersResult, startPassingTest, onResult, getPercentResultTest} = useContext(PassingTestContext);
  const successfulPassingTest = +countRightAnswers >= +minCorrectAnswerCount;

  const correctQuestions = () => {
    return questions?.map((question: IQuestion) => {
      return question.Answers.every(answer => !!answer.IsCorrect === !!answersResult[answer.ID]);
    });
  };

  const correctQuestionsCount = correctQuestions();
  const percentageCorrectAnswers = (correctQuestionsCount?.filter(correctQuestion => correctQuestion)?.length / questions.length) * 100;

  const backButton = (result: TEST_STATUSES) => {
    getPercentResultTest(Math.trunc(percentageCorrectAnswers));
    onResult(result);
    setOpenDialog(false);
    startPassingTest();
  };

  const restartTest = () => {
    setOpenDialog(false);

    questions?.forEach((question: IQuestion) => {
      question?.Answers?.forEach((answer: IAnswer) => {
        question.Type === QUESTION_TYPES.MULTIPLE ? setValue(answer.ID.toString(), false) : setValue(answer.ID.toString(), null);
      });
    });
  };

  return (
    <FlexRow className="flex items-center justify-between flex-nowrap font-medium text-black">
      <FlexCol className="shrink-0">
        <TGButton type="submit" onClick={() => setOpenDialog(true)} color="bluedark">
          Проверить
        </TGButton>
      </FlexCol>

      <Modal zIndex={70} open={openDialog} modalClassName="min-h-[296px]" toggleDialog={setOpenDialog}>
        <header className="px-10 pb-[38px]">{<h2>{successfulPassingTest ? "Тест пройден успешно" : "Тест не пройден"}</h2>}</header>

        <div className="px-10 pb-[38px] border-b">
          <h4 className="text-black ">
            Вы ответили правильно на {countRightAnswers} из {questions.length} вопросов.
          </h4>
          {!successfulPassingTest ? <h4 className="text-black">Пожалуйста, пройдите тест повторно.</h4> : ""}
        </div>

        <footer className="flex justify-center mx-auto w-full px-10 pt-10">
          {successfulPassingTest ? (
            <TGButton color="bluedark" onClick={() => backButton(TEST_STATUSES.COMPLETE_SUCCESSFUL)}>
              Закрыть
            </TGButton>
          ) : (
            <div className="flex justify-between w-full">
              <TGButton onClick={() => backButton(TEST_STATUSES.COMPLETE_WITH_ERROR)}>Закрыть тест</TGButton>
              <TGButton color="bluedark" onClick={restartTest}>
                Перейти к тесту
              </TGButton>
            </div>
          )}
        </footer>
      </Modal>
    </FlexRow>
  );
};

export default ModalResultPassingTest;
